<template>
  <b-container class="home-margin project-list">
    <Search
      :SearchTitle="SearchTitle"
      :show="searchShow"
      :HeaderClick="HeaderClick"
      :Title="headerTitle"
      :SearchContent="SearchContent"
      :ContentCLick="ContentCLick"
      :categoriesId="categoriesId"
      :type="searchType"
      :handleChange="handleChange"
      :More="more.show"
      :MoreText="more.text"
      :MoreClick="MoreClick"
      :cleanButton="cleanButton"
    ></Search>
    <b-row class="new-project">
      <div
        class="projects"
        v-for="(item, index) in projectData.data"
        :key="index"
      >
        <div class="project-content">
          <div class="projects-text">
            <h6 class="maxLength-text-1">{{ item.name }}</h6>
            <div class="flex-text">
              <div class="projects-flex-text">
                <span>项目类型</span>
                <Category :categoryId="item.categoryId"></Category>
              </div>
              <div class="projects-flex-text">
                <span>项目行业</span>
                <p v-if="item.industry">{{ item.industry.name }}</p>
              </div>
              <div class="projects-flex-text">
                <span>开始时间</span>
                <p>{{ changeDataTime(item.startDate) }}</p>
              </div>
            </div>
          </div>
          <div style="display:flex;flex-wrap: wrap">
            <div class="projects-wait-footer">
              <i></i>
              <span>
                {{ existData(item.areas[0], "provinceName", "") }}
                {{
                  item.areas[0] && item.areas[0].cityName
                    ? existData(item.areas[0], "cityName", " - ")
                    : ""
                }}
              </span>
            </div>
          </div>
        </div>
        <div class="projects-contexts">
          <p class="maxLength-text-2">{{ onDesc(item.projectDesc) }}</p>
          <a @click="ProjectDetail(item.id)">
            查看详情
            <i></i>
          </a>
        </div>
      </div>
    </b-row>
    <b-pagination
      v-if="page.show"
      class="solution-page"
      style="justify-content: center;"
      v-model="page.current"
      :total-rows="page.rows"
      :perPage="page.perPage"
      first-number
      last-number
    ></b-pagination>
    <a-modal
      v-model="visible"
      :title="modalText"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
      class="form-all"
    >
      <a-tree-select
        v-if="searchType == 'industry'"
        v-model="modalData"
        style="width: 100%"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="option"
        tree-data-simple-mode
      />
      <a-range-picker
        v-if="searchType == 'time'"
        @change="onChange"
        :placeholder="['开始时间', '结束时间']"
      />
    </a-modal>
  </b-container>
</template>
<script>
import Api from "@/apis";
import publicChange from "@/assets/js/index.js";
import Category from "@/components/category.vue";
export default {
  data() {
    return {
      modalText: "选择更多行业",
      routeStatus: this.$route.query.status || "",
      routeid: this.$route.query.id || null,
      modalData: "",
      visible: false,
      more: {
        show: false,
        text: "更多"
      },
      modalTimeData: [],
      searchShow: false,
      searchIndex: null,
      searchType: "project",
      AreaMore: false,
      searchText: "",
      logins: false,
      filters: {},
      page: {
        current: 1,
        rows: 1,
        perPage: 10,
        show: true
      },
      headerTitle: "筛选",
      categoriesId: 0,
      status: [
        {
          id: 1,
          name: "待启动",
          value: "pending"
        },
        {
          id: 2,
          name: "进行中-可加入",
          value: "allow"
        },
        {
          id: 3,
          name: "进行中-不可加入",
          value: "notallow"
        },
        {
          id: 4,
          name: "已完成",
          value: "done"
        }
      ],
      timeData: [
        {
          id: 1,
          name: "近一周",
          start: this.$moment()
            .week(this.$moment().week() - 1)
            .format("YYYY-MM-DD"),
          end: this.$moment().format("YYYY-MM-DD")
        },
        {
          id: 2,
          name: "近一月",
          start: this.$moment()
            .subtract(1, "month")
            .format("YYYY-MM-DD"),
          end: this.$moment().format("YYYY-MM-DD")
        },
        {
          id: 3,
          name: "近一年",
          start: this.$moment()
            .subtract(1, "year")
            .format("YYYY-MM-DD"),
          end: this.$moment().format("YYYY-MM-DD")
        }
      ],
      timeOldData: [
        {
          id: 1,
          name: "本周",
          start: this.$moment()
            .week(this.$moment().week())
            .startOf("week")
            .format("YYYY-MM-DD"),
          end: this.$moment()
            .week(this.$moment().week())
            .endOf("week")
            .format("YYYY-MM-DD")
        },
        {
          id: 2,
          name: "本月",
          start: this.$moment()
            .month(this.$moment().month())
            .startOf("month")
            .format("YYYY-MM-DD"),
          end: this.$moment()
            .month(this.$moment().month())
            .endOf("month")
            .format("YYYY-MM-DD")
        },
        {
          id: 3,
          name: "本年",
          start: this.$moment()
            .year(this.$moment().year())
            .startOf("year")
            .format("YYYY-MM-DD"),
          end: this.$moment()
            .year(this.$moment().year())
            .endOf("year")
            .format("YYYY-MM-DD")
        }
      ],
      SearchTitle: [
        {
          name: "项目类型",
          icon: false,
          active: false,
          type: "project",
          categoriesId: null
        },
        {
          name: "项目状态",
          icon: false,
          active: false,
          type: "status",
          categoriesId: null
        },
        {
          name: "项目所在地",
          icon: false,
          active: false,
          type: "area",
          categoriesId: null
        },
        {
          name: "项目行业",
          icon: false,
          active: false,
          type: "industry",
          categoriesId: null
        },
        {
          name: "开始时间",
          icon: false,
          active: false,
          type: "time",
          categoriesId: null
        }
      ],
      projectData: [],
      SearchContent: [],
      categoryAllData: [],
      areaData: [],
      treeData: [],
      option: []
    };
  },
  watch: {
    "page.current": {
      handler: function() {
        this.getProjectData();
        window, scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.getProjectAllCategories();
    this.getIndustry();
    this.getArea();

    if (this.login()) {
      this.logins = true;
    } else {
      this.logins = false;
      this.$message.warning("请先登录");
      this.$router.push({ path: "/login", query: { redirect: location.href } });
    }
  },
  components: {
    Category
  },
  methods: {
    //获取行业数据
    async getIndustry(id) {
      if (id) {
        let query = {
          filters: {
            id: id
          }
        };
        try {
          const data = await Api.Global.getIndustry(query);
          if (data.data && data.data.length > 0) {
            let industryArr = this.option;
            let arr = [];
            let tree = {
              id: data.data[0].id,
              name: data.data[0].name
            };
            if (industryArr && industryArr.length > 0) {
              industryArr.map(item => {
                arr.push(item.id);
              });
              if (arr.indexOf(data.data[0].id) > -1) {
                this.ContentCLick(tree, arr.indexOf(data.data[0].id));
              } else {
                industryArr.push(tree);
                this.treeData = industryArr;
                this.ContentCLick(tree, industryArr.length);
              }
            }
          }
        } catch (e) {
          this.$message.error(e);
        }
      } else {
        try {
          const data = await Api.Global.getIndustry();
          if (data) {
            this.treeData = data.data;
            this.option = data.data;
          }
        } catch (e) {
          this.$message.error(e);
        }
      }
    },
    //初始化获取类别
    async getProjectAllCategories() {
      let query = {
        current: 1
      };
      try {
        const data = await Api.Project.getProjectCategories(query);
        this.categoryAllData = data.data;
        //如果列表界面登录跳转进来自动筛选
        if (this.routeStatus && this.routeid && this.routeStatus !== "") {
          //处理类别
          if (data.data && data.data.length > 0) {
            data.data.map(item => {
              if (this.routeid == item.id) {
                this.SearchTitle[0].categoriesId = item.id;
                this.filters.categoryId = item.id;
                this.getProjectData();
                this.SearchTitle[0].name = item.name;
                this.SearchTitle[0].active = true;
                this.SearchTitle[0].icon = false;
              }
            });
          }
          //处理状态
          this.status.map(item => {
            if (this.routeStatus == item.value) {
              this.SearchTitle[1].categoriesId = item.id;
              this.filters.status = item.value;
              this.SearchTitle[1].name = item.name;
              this.SearchTitle[1].active = true;
              this.SearchTitle[1].icon = false;
            }
          });
          this.getProjectData();
        } else {
          this.getProjectData();
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    //筛选
    HeaderClick(item, index) {
      switch (index) {
        case 0:
          this.headerTitle = `按项目类型筛选`;
          break;
        case 1:
          this.headerTitle = `按项目状态筛选`;
          break;
        case 2:
          this.headerTitle = `按项目所在地筛选`;
          break;
        case 3:
          this.headerTitle = `按项目行业筛选`;
          break;
        case 4:
          this.headerTitle = `按开始时间筛选`;
          break;
      }
      this.searchType = item.type;
      this.searchIndex = index;
      this.getProjectCategories(item.type, index);
      for (let i in this.SearchTitle) {
        if (i == index) {
          this.searchShow = true;
          this.SearchTitle[i].icon = !this.SearchTitle[i].icon;
          if (!this.SearchTitle[i].icon) {
            this.searchShow = false;
          }
        } else {
          this.SearchTitle[i].icon = false;
        }
      }
    },

    //获取当前类别下所有项目或者全部项目
    //根据type条件筛选
    async getProjectData() {
      let filterList = JSON.parse(JSON.stringify(this.filters));
      let query = {
        pageSize: this.page.perPage,
        current: this.page.current,
        filters: filterList
      };
      try {
        const data = await Api.Project.getProject(query);
        this.projectData = data;
        this.page.rows = data.total;
        if (data.data && data.data.length > 0) {
          this.page.show = true;
        } else {
          this.page.show = false;
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    //根据筛选条件处理筛选项
    async getProjectCategories(type, index) {
      if (this.SearchTitle[index].categoriesId) {
        this.categoriesId = this.SearchTitle[index].categoriesId;
      } else {
        this.categoriesId = null;
      }
      switch (type) {
        case "project":
          this.SearchContent = this.categoryAllData;
          this.more.show = false;
          break;
        case "status":
          this.SearchContent = this.status;
          this.more.show = false;
          break;
        case "area":
          this.SearchContent = this.areaData.slice(0, 10);
          this.more.show = true;
          break;
        case "industry":
          this.SearchContent = this.treeData;
          this.more.show = true;
          break;
        case "time":
          this.SearchContent = this.timeData;
          this.more.text = "自定义";
          this.more.show = true;
          break;
      }
    },
    //点击选项事件
    ContentCLick(item, index) {
      console.log(index);
      this.searchShow = false;
      switch (this.searchType) {
        case "project":
          this.SearchTitle[0].categoriesId = item.id;
          this.filters.categoryId = item.id;
          this.SearchTitle[0].name = item.name;
          this.SearchTitle[0].active = true;
          this.SearchTitle[0].icon = false;
          break;
        case "status":
          this.SearchTitle[1].categoriesId = item.id;
          this.filters.status = item.value;
          this.SearchTitle[1].name = item.name;
          this.SearchTitle[1].active = true;
          this.SearchTitle[1].icon = false;
          break;
        case "area":
          this.SearchTitle[2].categoriesId = parseInt(item.code);
          this.filters.areaCode = item.code;
          this.SearchTitle[2].name = item.name;
          this.SearchTitle[2].active = true;
          this.SearchTitle[2].icon = false;
          break;
        case "industry":
          this.SearchTitle[3].categoriesId = parseInt(item.id);
          this.filters.industryId = item.id;
          this.SearchTitle[3].name = item.name;
          this.SearchTitle[3].active = true;
          this.SearchTitle[3].icon = false;
          break;
        case "time":
          this.SearchTitle[4].categoriesId = parseInt(item.id);
          this.filters.startDate = {
            start: item.start,
            end: item.end
          };
          // console.log(item.start);
          // console.log(item.end);
          this.SearchTitle[4].name = item.name;
          this.SearchTitle[4].active = true;
          this.SearchTitle[4].icon = false;
          break;
      }
      this.getProjectData();
    },
    //地区
    async getArea() {
      try {
        const data = await Api.Area.getArea();
        this.areaData = data.areas;
      } catch (e) {
        console.log(e);
      }
    },
    //更多按钮点击事件
    MoreClick() {
      if (this.searchType == "area") {
        this.AreaMore = true;
        this.SearchContent = this.areaData;
        this.more.show = false;
      } else if (this.searchType == "industry") {
        this.modalText = "选择更多行业";
        this.visible = true;
      } else if (this.searchType == "time") {
        this.modalText = "自定义开始时间";
        this.visible = true;
      }
    },
    //模态框确认处理数据
    handleOk() {
      if (this.searchType == "industry") {
        if (this.modalData !== "") {
          this.getIndustry(this.modalData);
        }
        this.visible = false;
      } else if (this.searchType == "time") {
        const TimeOld = JSON.parse(JSON.stringify(this.timeOldData));
        if (this.modalTimeData && this.modalTimeData.length > 0) {
          let data = {
            id: this.timeData.length + 1,
            start: this.modalTimeData[0],
            end: this.modalTimeData[1],
            name: `${this.modalTimeData[0]} 至 ${this.modalTimeData[1]}`
          };
          TimeOld.push(data);
          this.timeData = TimeOld;
          this.ContentCLick(data, this.timeData.length);
          this.getProjectData();
          this.more.show = false;
        }
        this.visible = false;
      }
    },
    //清除
    cleanButton() {
      switch (this.searchType) {
        case "project":
          this.SearchTitle[0].categoriesId = null;
          delete this.filters.categoryId;
          this.getProjectData();
          this.SearchTitle[0].name = "项目类型";
          this.SearchTitle[0].active = false;
          this.SearchTitle[0].icon = false;
          break;
        case "status":
          this.SearchTitle[1].categoriesId = null;
          delete this.filters.status;
          this.getProjectData();
          this.SearchTitle[1].name = "项目状态";
          this.SearchTitle[1].active = false;
          this.SearchTitle[1].icon = false;
          break;
        case "area":
          this.SearchTitle[2].categoriesId = null;
          delete this.filters.areaCode;
          this.getProjectData();
          this.SearchTitle[2].name = "所在地区";
          this.SearchTitle[2].active = false;
          this.SearchTitle[2].icon = false;
          break;
        case "industry":
          this.SearchTitle[3].categoriesId = null;
          delete this.filters.industryId;
          this.getProjectData();
          this.SearchTitle[3].name = "项目行业";
          this.SearchTitle[3].active = false;
          this.SearchTitle[3].icon = false;
          break;
        case "time":
          this.SearchTitle[4].categoriesId = null;
          delete this.filters.startDate;
          this.getProjectData();
          this.SearchTitle[4].name = "开始时间";
          this.SearchTitle[4].active = false;
          this.SearchTitle[4].icon = false;
          break;
      }
      this.categoryId = null;
      this.searchShow = false;
    },
    handleChange(val) {
      console.log(val);
    },
    //时间处理
    onChange(date, dateString) {
      this.modalTimeData = dateString;
      console.log(date);
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    login() {
      return publicChange.userLogin();
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    },
    ProjectDetail(id) {
      this.$router.push({
        path: `/product/projectDetails`,
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style scoped></style>
